<div *ngIf="inputOptions?.validation !== undefined" class="pa-meta pa-validation-error">
    <div *ngIf="(userText.length > 0 && !validateText(userText)) || validateVoiceText()">
        {{ inputOptions.validation.errorMessage }}
    </div>
</div>

<div *ngIf="attachmentError" class="pa-attachment-error">{{ 'ATTACHMENT_INVALID' | translate }}</div>

<div class="pa-input">
    <div *ngIf="attachmentsEnabled" class="pa-attach" (click)="fileInput.click()" [attr.title]="'ATTACHMENT_ADD' | translate">
        <input #fileInput type="file" [accept]="attachmentAccept" (change)="onAttachmentSelected($event)" hidden>
        <span class="pa-attach-button">
            <svg aria-hidden="true" class="pa-attach-button-icon" viewBox="0 0 24 24" role="img">
                <path fill="currentColor"
                      d="M16.5 6.5v9a4.5 4.5 0 1 1-9 0V5a3 3 0 0 1 6 0v9.5a1.5 1.5 0 1 1-3 0V6.5H9V14.5a3 3 0 0 0 6 0V5a4.5 4.5 0 0 0-9 0v10.5a6 6 0 1 0 12 0v-9h-1.5z"/>
            </svg>
        </span>
        <div *ngIf="selectedAttachment !== undefined" class="pa-attachment-preview" [attr.title]="selectedAttachment.name">
            <span class="pa-attachment-preview-name">{{ selectedAttachment.name }}</span>
            <button (click)="removeAttachment(); $event.stopPropagation()" class="pa-attachment-preview-remove" type="button"
                    [attr.aria-label]="'ATTACHMENT_REMOVE' | translate">&times;</button>
        </div>
    </div>
    <div #messageInput (focus)="onFocus()" (keydown)="onEnterPressed($event)" (keyup)="onKeyUp()"
         [contenteditableModel]="userText"
         (contenteditableModelChange)="userText = $event"
         [attr.placeholder]="(inputOptions?.placeholder === undefined) ? ('PLACEHOLDER' | translate) : inputOptions.placeholder"
         [class.pa-message-input-validation-error]="(userText.length > 0 && !validateText(userText)) || validateVoiceText()"
         [maxLength]="inputOptions?.maxInputLength"
         class="pa-message-input"
         contenteditable="true">
    </div>
    <button (click)="sendUserText()" *ngIf="!addVoiceInput || (addVoiceInput && ((inputFocus && userText.length > 0) || selectedAttachment !== undefined))"
            [disabled]="!canSendMessage()"
            class="pa-send-button"
            type="button">
        <svg aria-hidden="true" class="pa-send-button-icon" data-fa-processed="" data-icon="paper-plane"
             data-prefix="fas" role="img" viewBox="0 0 512 512">
            <path
                d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"></path>
        </svg>
    </button>
    <botato-text-voice-input *ngIf="addVoiceInput && (!inputFocus || (inputFocus && userText.length === 0)) && selectedAttachment === undefined"
                             [inputTextValidation]="inputOptions?.validation"></botato-text-voice-input>
</div>

<div *ngIf="inputOptions?.maxInputLength !== 0" class="pa-meta">
    <div [class.pa-letter-count-full]="userText.length === inputOptions?.maxInputLength" class="pa-letter-count">
        {{ 'CHARACTER_INDICATOR' | translate:{length: userText.length, maxLength: inputOptions?.maxInputLength} }}
    </div>
</div>
